import { DESKTOP_MIN_WIDTH } from 'constants';
import useLang from 'hooks/useLang';
import React from 'react';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';
import { ReferralContentTabStyled } from '../ReferralContentTab1';

const getReferrerSources = () => [
  {
    step: 1,
    imgSrc: 'link_reward_for_you_1',
  },
  {
    step: 2,
    imgSrc: 'link_reward_for_you_2',
  },
  {
    step: 3,
    imgSrc: 'link_reward_for_you_3',
  },
];
const getRefereeSources = () => [
  {
    step: 1,
    imgSrc: 'link_reward_for_your_friend_1',
  },
  {
    step: 2,
    imgSrc: 'link_reward_for_your_friend_2',
  },
  {
    step: 3,
    imgSrc: 'link_reward_for_your_friend_3',
  },
];

const ReferralContentTab2 = () => {
  const { t } = useLang();

  return (
    <ReferralContentTabStyled>
      <GridLayout>
        <GridItem>
          <LabelDescWrap>
            <Label>{t('label_for_you_label')}</Label>
          </LabelDescWrap>
          {getReferrerSources().map((s) => (
            <Image key={s.step} src={t(s.imgSrc)} />
          ))}
        </GridItem>
        <GridItem>
          <LabelDescWrap>
            <Label>{t('label_for_your_friend_label')}</Label>
          </LabelDescWrap>
          {getRefereeSources().map((s) => (
            <Image key={s.step} src={t(s.imgSrc)} />
          ))}
        </GridItem>
      </GridLayout>
    </ReferralContentTabStyled>
  );
};

const GridLayout = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: 100%;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    gap: 16px;
    grid-template-columns: repeat(2, calc((100% - 16px) / 2));
  }
`;

const GridItem = styled.div`
  border-radius: 10px;
  border: 1px dashed #7a8189;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 10px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    height: 100%;
  }
`;

const LabelDescWrap = styled.div``;
const Label = styled.p`
  ${paragraphMixin};
  font-weight: 500;
  margin: 0;
  text-transform: uppercase;
`;
const Desc = styled.p`
  ${paragraphMixin};
  font-weight: 500;
  color: #7a8189;
  margin: 0;
`;

export default ReferralContentTab2;
